import {
    Form,
    Input,
} from 'antd';
import type { FormInstance } from 'antd/es/form';
import { localize } from 'mixins/helpers';
import Button from 'mixins/ui/button/button';
import React, { FC } from 'react';
import { sanitizeTaxpayerCode } from '../utils/helpers';
import { ApiAccessFilterValues } from '../utils/types';
import { getTaxpayerCodeRule } from '../utils/validation';

interface ApiAccessFilterProps {
    disabled: boolean;
    form: FormInstance<ApiAccessFilterValues>;
    isLoading: boolean;
    translations: Record<string, string>;
    onReset: () => void;
    onSearch: (values: ApiAccessFilterValues) => void;
    onTaxpayerCodeChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const ApiAccessFilter: FC<ApiAccessFilterProps> = ({
    disabled,
    form,
    isLoading,
    onReset,
    onSearch,
    onTaxpayerCodeChange,
    translations,
}) => (
    <div className="admin-api-access__filters">
        <Form
            form={form}
            layout="vertical"
            onFinish={onSearch}
        >
            <div className="admin-api-access__filter-row">
                <div className="admin-api-access__filter-field">
                    <div className="admin-api-access__field-label">
                        {localize('admin-api-access-taxpayer-code', translations)}
                    </div>
                    <Form.Item
                        name="taxpayerCode"
                        normalize={sanitizeTaxpayerCode}
                        rules={[getTaxpayerCodeRule(translations, true)]}
                    >
                        <Input
                            maxLength={12}
                            inputMode="numeric"
                            placeholder={localize(
                                'admin-api-access-taxpayer-placeholder',
                                translations
                            )}
                            onChange={onTaxpayerCodeChange}
                        />
                    </Form.Item>
                </div>

                <div className="admin-api-access__filter-actions">
                    <Form.Item className="admin-api-access__actions">
                        <Button
                            color="gold"
                            htmlType="submit"
                            disabled={disabled}
                            loading={isLoading}
                        >
                            {localize('admin-api-access-search', translations)}
                        </Button>
                        <Button
                            htmlType="button"
                            disabled={disabled}
                            onClick={onReset}
                        >
                            {localize('admin-api-access-clear', translations)}
                        </Button>
                    </Form.Item>
                </div>
            </div>
        </Form>
    </div>
);